import Logo from './Logo'

export default function PublicLayout({ children, title }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 h-14 flex items-center">
          <Logo size="sm" />
          {title && (
            <span className="ml-4 text-gray-500 text-sm">— {title}</span>
          )}
        </div>
      </nav>
      <main className="max-w-4xl mx-auto px-4 py-8">
        {children}
      </main>
    </div>
  )
}
